import styled from "styled-components";
import { COLOR_PRIMARY_LIGHT } from "../../utilities/constants";

export const MainContainer = styled.div`
  margin-left: 40px;
  display: flex;
  flex-direction: column;
  background-color: ${COLOR_PRIMARY_LIGHT};
`;
